import * as React from 'react';
import { Route, Routes, Outlet, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import CurrencyList from '../pages/currency';
import UOMList from '../pages/uom';
import Dashboard from '../pages/dashboard';
import DepartmentList from '../pages/department';
import ClientList from '../pages/client';
import RoleAndPermission from '../pages/rolespermissions';
import UserList from '../pages/user';
import AuditTrail from '../pages/audit-trial';
import EmailLogs from '../pages/email-logs';
import Notifications from '../pages/notifications';
// import AuditTrialDetail from '../pages/audit-trial/details';
import CompanyList from '../pages/company';
import PaymentRequestList from '../pages/payment';
import PaymentRequestAdd from '../pages/payment/add';
import PaymentRequestEdit from '../pages/payment/edit';
import PaymentRequestView from '../pages/payment/view';
import PaymentRequestPreview from '../pages/payment/preview';
import PaymentSettings from '../pages/settings/payment';
import OfficeAddress from '../pages/settings/general/office';
import MailConfiguration from '../pages/settings/general/mailconfiguration';
import OfficeAddressAdd from '../pages/settings/general/add';
import OfficeAddressEdit from '../pages/settings/general/edit';
import OfficeAddressView from '../pages/settings/general/view';
import Transaction from '../pages/transaction';
// import TransactionInApp from '../pages/transaction/paymentgateway';
import TransactionItemView from '../pages/transaction/view';
import ManualTransactionView from '../pages/transaction/manual-view';
import UserProfile from '../pages/profile';
import BankConfiguration from '../pages/bank';
import BankConfigurationAdd from '../pages/bank/add';
import BankConfigurationEdit from '../pages/bank/edit';
import BankConfigurationView from '../pages/bank/view';
import SignatureSettings from '../pages/settings/signature';
import SignatureSettingsAdd from '../pages/settings/signature/add';
import SignatureSettingsEdit from '../pages/settings/signature/edit';
import SignatureSettingsView from '../pages/settings/signature/view';
import SummaryReport from '../pages/reports/summary';
import AgeingReport from '../pages/reports/ageing';
import FinancialYearReport from '../pages/reports/financialYearReport';
import ProtectedRoute from '../routers/protecedRoute';
// import useHasPermission from '../utils/useHasPermission';
import {
  address,
  auditTrail,
  bank,
  client,
  company,
  currency,
  department,
  mail,
  paymentRequest,
  paymentSettings,
  transaction,
  signature,
  report,
  uom,
  index,
  store,
  show,
  notification,
  update
  // destroy
} from '../utils/constants';

// import Sidebar from "./Sidebar";

function Header() {
  // const drawerWidth = 210;

  return (
    <Box className="contnenWrap" sx={{ position: 'relative', overflow: 'hidden' }}>
      <div className="content">
        <Routes>
          <Route exact path="/dashboard" element={<Dashboard />} />
          <Route
            exact
            path="/department"
            element={
              <ProtectedRoute module={department} permission={index} element={<DepartmentList />} />
            }
          />
          <Route
            exact
            path="/currency"
            element={
              <ProtectedRoute module={currency} permission={index} element={<CurrencyList />} />
            }
          />
          <Route
            exact
            path="/unit-of-measurement"
            element={<ProtectedRoute module={uom} permission={index} element={<UOMList />} />}
          />
          <Route
            exact
            path="/company"
            element={
              <ProtectedRoute module={company} permission={index} element={<CompanyList />} />
            }
          />
          <Route
            exact
            path="/client"
            element={<ProtectedRoute module={client} permission={index} element={<ClientList />} />}
          />
          <Route exact path="/roles-permissions" element={<RoleAndPermission />} />
          <Route
            path="/payment-request"
            element={
              <ProtectedRoute module={paymentRequest} permission={index} element={<Outlet />} />
            }
          >
            <Route index element={<PaymentRequestList />} />
            <Route
              path="add"
              element={
                <ProtectedRoute
                  module={paymentRequest}
                  permission={store}
                  element={<PaymentRequestAdd />}
                />
              }
            />
            <Route
              path="edit/:code"
              element={
                <ProtectedRoute
                  module={paymentRequest}
                  permission={update}
                  element={<PaymentRequestEdit />}
                />
              }
            />
            <Route
              path="view/:code"
              element={
                <ProtectedRoute
                  module={paymentRequest}
                  permission={show}
                  element={<PaymentRequestView />}
                />
              }
            />
            <Route
              path="preview/:code"
              element={
                <ProtectedRoute
                  module={paymentRequest}
                  permission={update}
                  element={<PaymentRequestPreview />}
                />
              }
            />
          </Route>
          <Route
            path="/settings/bank"
            element={<ProtectedRoute module={bank} permission={index} element={<Outlet />} />}
          >
            <Route index element={<BankConfiguration />} />
            <Route
              path="add"
              element={
                <ProtectedRoute
                  module={bank}
                  permission={store}
                  element={<BankConfigurationAdd />}
                />
              }
            />
            <Route
              path="edit/:code"
              element={
                <ProtectedRoute
                  module={bank}
                  permission={update}
                  element={<BankConfigurationEdit />}
                />
              }
            />
            <Route
              path="view/:code"
              element={
                <ProtectedRoute
                  module={bank}
                  permission={show}
                  element={<BankConfigurationView />}
                />
              }
            />
          </Route>
          <Route
            path="/settings/signature"
            element={<ProtectedRoute module={signature} permission={index} element={<Outlet />} />}
          >
            <Route index element={<SignatureSettings />} />
            <Route
              path="add"
              element={
                <ProtectedRoute
                  module={signature}
                  permission={store}
                  element={<SignatureSettingsAdd />}
                />
              }
            />
            <Route
              path="edit/:code"
              element={
                <ProtectedRoute
                  module={signature}
                  permission={update}
                  element={<SignatureSettingsEdit />}
                />
              }
            />
            <Route
              path="view/:code"
              element={
                <ProtectedRoute
                  module={signature}
                  permission={show}
                  element={<SignatureSettingsView />}
                />
              }
            />
          </Route>
          <Route
            path="/transaction"
            element={
              <ProtectedRoute module={transaction} permission={index} element={<Outlet />} />
            }
          >
            <Route index element={<Navigate to="/transaction/in-app" replace />} />
            <Route path="*" element={<Transaction />} />
          </Route>
          <Route
            exact
            path="/transaction/in-app/view/:code"
            element={
              <ProtectedRoute
                module={transaction}
                permission={index}
                element={<TransactionItemView />}
              />
            }
          />
          <Route
            exact
            path="/transaction/manual/view/:code"
            element={
              <ProtectedRoute
                module={transaction}
                permission={index}
                element={<ManualTransactionView />}
              />
            }
          />
          <Route
            exact
            path="/settings/payment"
            element={
              <ProtectedRoute
                module={paymentSettings}
                permission={index}
                element={<PaymentSettings />}
              />
            }
          />
          <Route
            exact
            path="/settings"
            element={
              <ProtectedRoute module={address} permission={index} element={<OfficeAddress />} />
            }
          />
          <Route
            exact
            path="/settings/office-add"
            element={
              <ProtectedRoute module={address} permission={store} element={<OfficeAddressAdd />} />
            }
          />
          <Route
            exact
            path="/settings/office-edit/:code"
            element={
              <ProtectedRoute
                module={address}
                permission={update}
                element={<OfficeAddressEdit />}
              />
            }
          />
          <Route
            exact
            path="/settings/office-view/:code"
            element={
              <ProtectedRoute module={address} permission={show} element={<OfficeAddressView />} />
            }
          />
          <Route
            exact
            path="/settings/mail"
            element={
              <ProtectedRoute module={mail} permission={index} element={<MailConfiguration />} />
            }
          />
          <Route
            exact
            path="/user"
            element={<ProtectedRoute module="user" permission={index} element={<UserList />} />}
          />
          <Route
            exact
            path="/reports/summary"
            element={
              <ProtectedRoute module={report} permission={index} element={<SummaryReport />} />
            }
          />
          <Route
            exact
            path="/reports/financial-year"
            element={
              <ProtectedRoute
                module={report}
                permission={index}
                element={<FinancialYearReport />}
              />
            }
          />
          <Route
            exact
            path="/reports/ageing"
            element={
              <ProtectedRoute module={report} permission={index} element={<AgeingReport />} />
            }
          />
          <Route
            exact
            path="/notifications"
            element={
              <ProtectedRoute
                module={notification}
                permission={index}
                element={<Notifications />}
              />
            }
          />
          <Route
            exact
            path="/audit-trial"
            element={
              <ProtectedRoute module={auditTrail} permission={index} element={<AuditTrail />} />
            }
          />
          <Route
            exact
            path="/email-logs"
            element={
              <ProtectedRoute module={EmailLogs} permission={index} element={<EmailLogs />} />
            }
          />
          {/* <Route
            exact
            path="/audit-trial/view/:code"
            element={
              <ProtectedRoute
                module="audit_trail"
                permission="view"
                element={<AuditTrialDetail />}
              />
            }
          /> */}
          <Route exact path="/profile" element={<UserProfile />} />
        </Routes>
        {/* <Routes>
          <Route exact path="/dashboard" element={<Dashboard />} />
          <Route exact path="/department" element={<DepartmentList />} />
          <Route exact path="/currency" element={<CurrencyList />} />
          <Route exact path="/unit-of-measurement" element={<UOMList />} />
          <Route exact path="/company" element={<CompanyList />} />
          <Route exact path="/client" element={<ClientList />} />
          <Route exact path="/roles-permisions" element={<RoleAndPermission />} />
          <Route path="/payment-request">
            <Route index element={<PaymentRequestList />} />
            <Route path="add" element={<PaymentRequestAdd />} />
            <Route path="edit/:code" element={<PaymentRequestEdit />} />
            <Route path="view/:code" element={<PaymentRequestView />} />
            <Route path="preview/:code" element={<PaymentRequestPreview />} />
          </Route>
          <Route path="/settings/bank">
            <Route index element={<BankConfiguration />} />
            <Route path="add" element={<BankConfigurationAdd />} />
            <Route path="edit/:code" element={<BankConfigurationEdit />} />
            <Route path="view/:code" element={<BankConfigurationView />} />
          </Route>
          <Route path="/transaction">
            <Route index element={<Navigate to="/transaction/in-app" replace />} />
            <Route path="*" element={<Transaction />} />
          </Route>
          <Route exact path="/transaction/in-app/view/:code" element={<TransactionItemView />} />
          <Route exact path="/transaction/manual/view/:code" element={<ManualTransactionView />} />
          <Route exact path="/settings/payment" element={<PaymentSettings />} />
          <Route exact path="/settings" element={<GeneralSettings />} />
          <Route exact path="/settings/office-add" element={<OfficeAddressAdd />} />
          <Route exact path="/settings/office-edit/:code" element={<OfficeAddressEdit />} />
          <Route exact path="/settings/office-view/:code" element={<OfficeAddressView />} />
          <Route exact path="/user" element={<UserList />} />
          <Route exact path="/audit-trial" element={<AuditTrail />} />
          <Route exact path="/audit-trial/view/:code" element={<AuditTrialDetail />} />
          <Route exact path="/profile" element={<UserProfile />} />
        </Routes> */}
      </div>
    </Box>
  );
}

export default Header;
